
import CenteredLayout from '@/components/layouts/CenteredLayout.vue'
import { defineComponent } from 'vue'
import { Form as VeeForm } from 'vee-validate'
import { ref } from 'vue'
import { LoginRequest } from '@/models/auth'
import auth from '@/plugins/firebase/auth'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { EMAIL_NOT_VERIFIED } from '@/config/variables'

export default defineComponent({
  components: { CenteredLayout, VeeForm },
  setup() {
    const initialValues = ref({
      name: '',
      email: ''
    })
    const { t } = useI18n()
    const message = ref<{
      type: string
      text: string | null
    }>({
      type: 'success',
      text: null
    })
    const showSuccessMessage = ref(true)
    const store = useStore()
    const setCurrentUser = () => store.dispatch('fetchCurrentUser')
    const errorMessage = ref()
    const router = useRouter()
    const loading = ref(false)
    const handleSubmit = async (values: LoginRequest): Promise<void> => {
      loading.value = true
      try {
        const response = await auth.singin(values)
        // // console.log(response)
        setCurrentUser()
        router.push({ name: 'Messenger' })
        loading.value = false
      } catch (e: any) {
        // // console.log(e.code, e.message)
        message.value.type = 'error'
        if (e.code && e.message) {
          if (e.code == 'auth/user-not-found') {
            message.value.text = t('auth.user_not_found_text')
          } else {
            message.value.text = `Error ${e.code}: ${e.message}`
          }
        } else {
          if (e == EMAIL_NOT_VERIFIED) {
            message.value.text = t('signin.email_not_verified_text')
          }
        }

        console.error(e)

        loading.value = false
      }
    }

    return {
      showSuccessMessage,
      loading,
      initialValues,
      handleSubmit,
      message,
      errorMessage
    }
  }
})
